<template>
  <div class="container">
    <!-- ////////////// Header Start ////////////// -->
    <app-header></app-header>
    <!-- ////////////// Header End ////////////// -->
      <div style="padding-top: 150px;"></div>
      <div>
        <div class="arrow"></div>
        <div class="h2-arrow">MENTIONS<br/>OBLIGATOIRES</div>
      </div>
      <div class="nota-bene col-md-9">
        <div class="h4-sub-title-medium">Pour rappel, votre-espace.bimediatv.com est uniquement dédié à la diffusion de messages d'information et/ou de promotion de votre point de vente et des produits à disposition.</div>
        <div class="h4-sub-title-medium">Vous êtes tenus de connaître et respecter les lois en vigueur.</div>
        <div class="h4-sub-title-medium">Vous trouverez ci-dessous l'ensemble des mentions légales à intégrer à toute communication publicitaire sous le coup de la Loi Sapin et de la loi Santé 2015 notamment.</div>
      </div>
      <div class="h3-sub-title bold orange">Pour tout produit alcoolisé :</div>
      <p class="col-md-12"><span class="bold underline">
        "L’abus d’alcool est dangereux pour la santé. A consommer avec modération"</span>
      </p>
      <div class="h3-sub-title bold orange">Pour les "boissons sucrées" et produits alimentaires type confiserie :</div>
      <p class="col-md-12">
          l'un des 4 messages sanitaires suivants suivi de l'adresse du site internet <a href="http://www.mangerbouger.fr" target="_blank" style="color: var(--fourth-color);" class="bold underline">www.mangerbouger.fr</a> :
          <ul>
            <li class="orange-list bold">Pour votre santé, mangez au moins cinq fruits et légumes par jour ; <a href="http://www.mangerbouger.fr" target="_blank" style="color: var(--fourth-color);" class="bold underline">www.mangerbouger.fr</a></li>
            <li class="orange-list bold">Pour votre santé, pratiquez une activité physique régulière ; <a href="http://www.mangerbouger.fr" target="_blank" style="color: var(--fourth-color);" class="bold underline">www.mangerbouger.fr</a></li>
            <li class="orange-list bold">Pour votre santé, évitez de manger trop gras, trop sucré, trop salé ; <a href="http://www.mangerbouger.fr" target="_blank" style="color: var(--fourth-color);" class="bold underline">www.mangerbouger.fr</a></li>
            <li class="orange-list bold">Pour votre santé, évitez de grignoter entre les repas ; <a href="http://www.mangerbouger.fr" target="_blank" style="color: var(--fourth-color);" class="bold underline">www.mangerbouger.fr</a></li>
          </ul>
      </p>
      <div class="h3-sub-title bold orange">Pour tout produit lié aux jeux d'argent, paris en ligne (ex : PMU, FDJ, jeux de grattages, ...) :</div>
      <p class="col-md-12">
          l'un des 2 messages sanitaires suivants :
          <ul>
            <li class="orange-list bold">"Famille, vie sociale, santé financière. Etes-vous prêt à tout miser ? Pour être aidé, appelez le 09-74-75-13-13 (appel non surtaxé)"</li>
            <li class="orange-list bold">"Jouer comporte des risques : endettement, isolement, dépendance. Pour être aidé, appelez le 09-74-75-13-13 (appel non surtaxé)"</li>
          </ul>
      </p>
      <div class="h3-sub-title bold orange">Pour tout produit lié au tabac (filtres, papier, tubes, cigarettes/cigares/...) ou à la Vape :</div>
      <p class="col-md-12 columns">
        Attention depuis le 31 janvier 2016, toute <span class="bold underline">publicité directe ou indirecte</span> en faveur du <span class="bold">tabac</span>, des <span class="bold">produits du tabac</span> ou <span class="bold">des ingrédients</span> définis au deuxième alinéa de <a href="http://www.legifrance.gouv.fr/affichCodeArticle.do?cidTexte=LEGITEXT000006072665&idArticle=LEGIARTI000006688198&dateTexte=&categorieLien=cid" target="_blank" style="color: var(--fourth-color);" class="bold underline"><strong>l'article L. 3511-1</strong></a> du Code de la Santé Publique est interdite. Seules sont permises les <span class="bold">affichettes</span> relatives aux <span class="bold">dispositifs électroniques de vapotage</span> et aux flacons de recharge qui leur sont associés, disposées à l’intérieur des établissements les commercialisant <span class="bold">et non visibles de l’extérieur</span>.
      </p>
      <div style="padding-top: 500px;"></div>
    <!-- ////////////// Footer Start ////////////// -->
    <app-footer></app-footer>
    <!-- ////////////// Footer End ////////////// -->
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
export default {
  name: 'mentions-legales',
  data () {
    return {
      msg: 'Mentions Légales'
    }
  },
  components: {
    'app-header': Header,
    'app-footer': Footer
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  
  p {
    text-align: justify;
    padding-bottom: 25px;
  }

  .container {
    text-align: left;
    padding-bottom: 100px;
  }

  .columns {
      text-align: justify;
      -webkit-column-count: 2; /* Chrome, Safari, Opera */
      -moz-column-count: 2; /* Firefox */
      column-count: 2;
      -webkit-column-gap: 40px; /* Chrome, Safari, Opera */
      -moz-column-gap: 40px; /* Firefox */
      column-gap: 40px;
  }

  .underline {
    text-decoration: underline;
  }

  .bold {
    font-weight: bold;
  }

  .green {
    color: var(--green-third-color);
  }

  .orange {
    color: var(--fourth-color);
  }

  .nota-bene {
    border-radius: 10px;
    color: var(--secondary-color);
    padding: 0 30px;
    border: 3px dashed var(--fifth-color);
    margin: 0 0 15px 15px;
  }

</style>



// WEBPACK FOOTER //
// MentionsLegales.vue?30044048